export default __webpack_public_path__ + "static/media/calendar3.500feedc.png";